import Account from "@/helper/AccountHelper.js";

export const StaticLevel = {
    Member: {indexLevel:0,level:1,name:"Member"},
    Silver: {indexLevel:1,level:2,name:"Silver"},
    Gold: {indexLevel:2,level:4,name:"Gold"},
    Platinum: {indexLevel:3,level:8,name:"Platinum"},
    VIP_Gold: {indexLevel:4,level:16,name:"VIP-Gold"},
    VIP_Platinum: {indexLevel:5,level:32,name:"VIP-Platinum"},
    TRO_2: {indexLevel:6,level:64,name:"TRO2"},
    TRO_3: {indexLevel:7,level:128,name:"Health+"},
    SEIC_1: {indexLevel:8,level:256,name:"VIP Gold (Health+)"},
    SEIC_2: {indexLevel:9,level:512,name:"VIP Platinum (Health+)"},
    SEIC_3: {indexLevel:10,level:1024,name:"VIP Diamond (Health+)"},
    SELIC_1: {indexLevel:11,level:2048,name:"SELIC 1"},
    SELIC_2: {indexLevel:12,level:4096,name:"SELIC 2"},
    SELIC_3: {indexLevel:13,level:8192,name:"SELIC 3"},
    SECAP_1: {indexLevel:14,level:16384,name:"SECAP 1"},
    SECAP_2: {indexLevel:15,level:32768,name:"SECAP 2"},
    // SECAP_3: {indexLevel:16,level:65536,name:"SECAP 3"}, level verifiedlaserno
    TCC_1: {indexLevel:17,level:131072,name:"TCC 1"},
    TCC_2: {indexLevel:18,level:262144,name:"TCC 2"},
    TCC_3: {indexLevel:19,level:524288,name:"TCC 3"},
    Consent: {indexLevel:20,level:1048576,name:"Consent"},
    VIP_Diamond: {indexLevel:21,level:2097152,name:"VIP-Diamond"},
    VIP_Diamond_2: {indexLevel:22,level:4194304,name:"VIP-Diamond 2"},
    VIP_Diamond_3: {indexLevel:23,level:8388608,name:"VIP-Diamond 3"},
    VIP_Diamond_4: {indexLevel:24,level:16777216,name:"VIP-Diamond 4"},
    VIP_Diamond_5: {indexLevel:25,level:33554432,name:"VIP-Diamond 5"},
    VIP_Platinum_2: {indexLevel:26,level:67108864,name:"VIP-Platinum 2"},
    VIP_Platinum_3: {indexLevel:27,level:134217728,name:"VIP-Platinum 3"},
    VIP_Platinum_4: {indexLevel:28,level:268435456,name:"VIP-Platinum 4"},
    VIP_Platinum_5: {indexLevel:29,level:536870912,name:"VIP-Platinum 5"},
    VIP_Gold_2: {indexLevel:30,level:1073741824,name:"VIP-Gold 2"},
    VIP_Gold_3: {indexLevel:31,level:2147483648,name:"VIP-Gold 3"},
    VIP_Gold_4: {indexLevel:32,level:4294967296,name:"VIP-Gold 4"},
    VIP_Gold_5: {indexLevel:33,level:8589934592,name:"VIP-Gold 5"},
    VIP_Diamond_6: {indexLevel:34,level:17179869184,name:"VIP-Diamond 6"},
    VIP_Diamond_7: {indexLevel:35,level:34359738368,name:"VIP-Diamond 7"},
    VIP_Diamond_8: {indexLevel:36,level:68719476736,name:"VIP-Diamond 8"},
    VIP_Platinum_6: {indexLevel:37,level:137438953472,name:"VIP-Platinum 6"},
    VIP_Platinum_7: {indexLevel:38,level:274877906944,name:"VIP-Platinum 7"},
    VIP_Platinum_8: {indexLevel:39,level:549755813888,name:"VIP-Platinum 8"},
    VIP_Gold_6: {indexLevel:40,level:1099511627776,name:"VIP-Gold 6"},
    VIP_Gold_7: {indexLevel:41,level:2199023255552,name:"VIP-Gold 7"},
    VIP_Gold_8: {indexLevel:42,level:4398046511104,name:"VIP-Gold 8"},
    Platinum_2: {indexLevel:43,level:8796093022208,name:"Platinum 2"},
    Platinum_3: {indexLevel:44,level:17592186044416,name:"Platinum 3"},
    Gold_2: {indexLevel:45,level:35184372088832,name:"Gold 2"},
    Gold_3: {indexLevel:46,level:70368744177664,name:"Gold 3"},
    Silver_2: {indexLevel:47,level:140737488355328,name:"Silver 2"},
    Silver_3: {indexLevel:48,level:281474976710656,name:"Silver 3"},
    Member_2: {indexLevel:49,level:562949953421312,name:"Member 2"},
    Member_3: {indexLevel:50,level:1125899906842624,name:"Member 3"},
    Blacklist: {indexLevel:62,level:4611686018427387904,name:"Blacklist"},
};

export function UserLevel() {
    this.userLevel = Account.getUserLevelDetail();

    this.checkLevel = function (indexLevel) {
        let rs = this.userLevel[indexLevel];

        if (rs) {
            return rs != '0';
        } else {
            return false;
        }
    }

    this.getLevelName = function (staticLevel) {
        let levelName = "";
        for (const key of Object.keys(staticLevel)) {
            if (this.checkLevel(staticLevel[key].indexLevel)) {
                levelName = staticLevel[key].name;
            }
        }
        return levelName;
    }

    this.getLevelVerifiedlaserno = function () {
        // return this.checkLevel(16);
        return true;
    }

}
